/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class expandCollapseAPI
 * @hideconstructor
 */
define([], () => {
	return class ExpandCollapseAPI {

		/**
		 * @description adds detail to a hierarchy dataitem model by including passed in child
		 * @function expandCollapseAPI#expand
		 * @public
		 *
		 * @param {String} dataItemId unique id representing the dataitem
		 * @param {String} parentUseValue value representing current parent
		 * @param {String} currentUseValue value representing child
		 *
		 * @return {Promise} resolves when model updated
		 */
		expand(/* dataItemId, parentUseValue, currentUseValue */) {}

		/**
		 * @description removes detail from a hierarchy dataitem model by removing passed in child
		 * @function expandCollapseAPI#collapse
		 * @public
		 *
		 * @param {String} dataItemId unique id representing the dataitem
		 * @param {String} parentUseValue value representing current parent
		 * @param {String} currentUseValue value representing child
		 *
		 * @return {Promise} resolves when model updated
		 */
		collapse(/* dataItemId, parentUseValue, currentUseValue */) {}
	};
});
